module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("96G9X"))).then(() => parcelRequire('iDabs'));